import * as React from "react"

export interface BreadcrumbComponentProps {
    breadcrumbs: Array<Breadcrumb>
}

export interface Breadcrumb {
    text: string
    function?: Function
}

const BreadcrumbComponent = (props: BreadcrumbComponentProps) => {
    return (
        <div className="row ">
            {props.breadcrumbs.map((breadcrumb, index) => {
                return (
                    breadcrumb.function ?
                        <div className={index > 0 ? "col-auto px-0" : "col-auto pe-0"} key={index} >
                            <a href="#" onClick={() => breadcrumb.function!()}>{breadcrumb.text}</a>
                            &ensp;&#62;&#62;&ensp;
                        </div>
                        :
                        <div className={index > 0 ? "col-auto px-0" : "col-auto pe-0"} key={index} >{breadcrumb.text}</div>
                )
            })}
            <hr />
        </div>
    )
}

export default BreadcrumbComponent